<div class="rfp-container">
    <img src="{{ icon }}" alt="" />
    <h1>{{ title }}</h1>
    <h2>{{ description }}</h2>
    <div class="buttons-container">
        <button class="download" (click)="onFirstButtonClick.emit()">
            {{ firstButtonText }}
        </button>
        <button class="restart" (click)="onSecondButtonClick.emit()">
            {{ secondButtonText }}
        </button>
    </div>

    <img src="../../../../../assets/images/LenAI-3.svg" alt="" />
</div>
